import { render, staticRenderFns } from "./T1TopOffers.vue?vue&type=template&id=8ff43770&scoped=true&"
import script from "./T1TopOffers.vue?vue&type=script&lang=js&"
export * from "./T1TopOffers.vue?vue&type=script&lang=js&"
import style0 from "./T1TopOffers.vue?vue&type=style&index=0&id=8ff43770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff43770",
  null
  
)

export default component.exports